import { CasePermissionsType, CaseTeamMemberPermissionsType } from 'src/types';

const DEFAULT_VIEW_PERMISSIONS: CasePermissionsType[] = [
  'VIEW_CASE_DETAILS',
  'VIEW_CASE_WORKSPACE_TAB',
  'VIEW_REPORT_DETAILS',
  'VIEW_CASE_AUDIT_LOGS_TAB',
  'VIEW_CASE_DETAILS_PII',
  'VIEW_REPORT_DETAILS_PII',
];

const DEFAULT_EDIT_PERMISSIONS: CasePermissionsType[] = [
  'EDIT_CASE_DETAILS',
  'EDIT_CASE_WORKSPACE_TAB',
  'EDIT_REPORT_DETAILS',
  'VIEW_CASE_AUDIT_LOGS_TAB',
  'VIEW_CASE_DETAILS_PII',
  'VIEW_REPORT_DETAILS_PII',
];

const ONLY_EDIT_PERMISSIONS: CasePermissionsType[] = [
  'EDIT_CASE_DETAILS',
  'EDIT_CASE_WORKSPACE_TAB',
  'EDIT_REPORT_DETAILS',
];

export const CASE_TABLE_PERMISSIONS: CasePermissionsType[] = [
  'VIEW_CASE',
  'VIEW_CASE_ON_CASES_TABLE',
];

export const accessStepPermissionHelper = (
  permissions: CaseTeamMemberPermissionsType[],
  unableToChat: boolean | undefined,
) => {
  const ALL_VIEW_PERMISSIONS: CasePermissionsType[] = unableToChat
    ? DEFAULT_VIEW_PERMISSIONS
    : [...DEFAULT_VIEW_PERMISSIONS, 'VIEW_REPORT_MESSAGES'];

  const ALL_EDIT_PERMISSIONS: CasePermissionsType[] = unableToChat
    ? DEFAULT_EDIT_PERMISSIONS
    : [...DEFAULT_EDIT_PERMISSIONS, 'SEND_REPORT_MESSAGES'];

  const FILTERED_EDIT_PERMISSIONS: CasePermissionsType[] = unableToChat
    ? ONLY_EDIT_PERMISSIONS
    : [...ONLY_EDIT_PERMISSIONS, 'SEND_REPORT_MESSAGES'];

  const disabledViewReportPII =
    !permissions.includes('VIEW_REPORT_DETAILS') &&
    !permissions.includes('EDIT_REPORT_DETAILS');

  const hasViewReportPII =
    permissions.includes('VIEW_REPORT_DETAILS_PII') && !disabledViewReportPII;

  const disabledViewCasePII =
    !permissions.includes('VIEW_CASE_DETAILS') &&
    !permissions.includes('EDIT_CASE_DETAILS');

  const hasViewCasePII =
    permissions.includes('VIEW_CASE_DETAILS_PII') && !disabledViewCasePII;

  const hasAllViewPermissions = ALL_VIEW_PERMISSIONS.every((permission) =>
    permissions.includes(permission),
  );

  const hasSomeEditPermissions = FILTERED_EDIT_PERMISSIONS.some((permission) =>
    permissions.includes(permission),
  );

  const hasAllEditPermissions = ALL_EDIT_PERMISSIONS.every((permission) =>
    permissions.includes(permission),
  );

  return {
    hasViewReportPII,
    hasViewCasePII,
    hasAllViewPermissions,
    hasAllEditPermissions,
    hasSomeEditPermissions,
    disabledViewReportPII,
    disabledViewCasePII,
    ALL_VIEW_PERMISSIONS,
    ALL_EDIT_PERMISSIONS,
    FILTERED_EDIT_PERMISSIONS,
  };
};
